import * as React from 'react';
import { UIHeading2, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IHowItWorkItemProps {
  stepNumber: number;
  title: string;
  description: string;
}

export const HowItWorkItem: React.FC<IHowItWorkItemProps> = ({ stepNumber, title, description }) => {
  return (
    <div className={styles['item']}>
      <div className={styles['step-number']}>
        <UIHeading2 color="text-secondary-default">{stepNumber}</UIHeading2>
      </div>

      <div className={styles['title']}>
        <UIHeading2 color="text-primary-default">{title}</UIHeading2>
        <UIText1 color="text-secondary-default">{description}</UIText1>
      </div>
    </div>
  );
};
